import React from "react";
import "../TermsAndConditions.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";

import {
  FiChevronRight,
  FiFileText,
  FiShield,
  FiLock,
  FiAlertCircle,
  FiCheckCircle,
  FiMail,
  FiRefreshCw,
} from "react-icons/fi";

const TermsAndConditions = () => {
  return (
    <>
      <Header />

      <div className="terms-page">

        {/* ================= HERO ================= */}

        <section className="terms-hero">

          <div className="container">

            <div className="terms-hero-content">

              <span className="terms-tag">
                TERMS & CONDITIONS
              </span>

              <h1>
                Terms &
                <span> Conditions</span>
              </h1>

              <p>
                These Terms & Conditions govern your use of the Saivari Fintech
                Private Limited website and services. By accessing our website,
                you agree to comply with these terms and all applicable laws and
                regulations.
              </p>

            </div>

          </div>

        </section>

        {/* ================= BREADCRUMB ================= */}

        <section className="terms-breadcrumb">

          <div className="container">

            <Link to="/">Home</Link>

            <FiChevronRight />

            <span>Terms & Conditions</span>

          </div>

        </section>

        {/* ================= CONTENT ================= */}

        <section className="terms-content">

          <div className="container">

            <div className="terms-wrapper">

              <div className="terms-updated">

                <FiRefreshCw />

                <span>Last Updated: July 2026</span>

              </div>

              {/* 1 */}

              <div className="terms-section">

                <h2>
                  <FiFileText />
                  Acceptance of Terms
                </h2>

                <p>
                  By accessing or using this website, you acknowledge that you
                  have read, understood, and agree to be bound by these Terms &
                  Conditions. If you do not agree with these terms, please do
                  not use this website.
                </p>

              </div>

              {/* 2 */}

              <div className="terms-section">

                <h2>
                  <FiShield />
                  Use of Website
                </h2>

                <p>
                  You agree to use this website only for lawful purposes and in
                  a manner that does not infringe upon the rights of others or
                  restrict their use of the website.
                </p>

                <ul>
                  <li>Use the website responsibly.</li>
                  <li>Do not attempt unauthorized access.</li>
                  <li>Do not introduce malicious software.</li>
                  <li>Do not misuse or copy website content.</li>
                </ul>

              </div>

              {/* 3 */}

              <div className="terms-section">

                <h2>
                  <FiLock />
                  Intellectual Property
                </h2>

                <p>
                  All website content including text, graphics, logos, software,
                  icons, designs, and other materials are the property of
                  Saivari Fintech Private Limited unless otherwise stated.
                </p>

                <p>
                  You may not copy, reproduce, modify, distribute, or publish
                  any material without prior written permission.
                </p>

              </div>

              {/* 4 */}

              <div className="terms-section">

                <h2>
                  <FiCheckCircle />
                  Services
                </h2>

                <p>
                  Information provided on this website is for general business
                  information only and does not constitute financial, legal, or
                  regulatory advice.
                </p>

                <ul>
                  <li>FinTech Consulting</li>
                  <li>Payment Solutions</li>
                  <li>AML Managed Services</li>
                  <li>KYC Verification</li>
                  <li>Compliance Support</li>
                  <li>Third-Party Risk Management</li>
                </ul>

              </div>

              {/* 5 */}

              <div className="terms-section">

                <h2>
                  <FiAlertCircle />
                  Limitation of Liability
                </h2>

                <p>
                  Saivari Fintech Private Limited shall not be liable for any
                  direct, indirect, incidental, or consequential damages arising
                  from your use of this website or reliance on its content.
                </p>

              </div>

              {/* 6 */}

              <div className="terms-section">

                <h2>
                  <FiShield />
                  User Responsibilities
                </h2>

                <ul>
                  <li>Provide accurate information where required.</li>
                  <li>Maintain confidentiality of submitted information.</li>
                  <li>Comply with all applicable laws.</li>
                  <li>Respect intellectual property rights.</li>
                </ul>

              </div>

              {/* 7 */}

              <div className="terms-section">

                <h2>
                  <FiRefreshCw />
                  Changes to Terms
                </h2>

                <p>
                  We reserve the right to modify these Terms & Conditions at any
                  time without prior notice. Continued use of the website
                  constitutes acceptance of the updated terms.
                </p>

              </div>

              {/* CONTACT */}

              {/* <div className="terms-contact">

                <h3>Need Assistance?</h3>

                <p>
                  If you have any questions regarding these Terms &
                  Conditions, please contact us.
                </p>

                <p>

                  <FiMail /> &nbsp;

                  contact@saivarifintech.com

                </p>

              </div> */}

            </div>

          </div>

        </section>

      </div>

      <Footer />
    </>
  );
};

export default TermsAndConditions;